import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FlashcardService } from 'src/app/core/flashcard.service';

@Component({
  selector: 'app-learn-success-view',
  templateUrl: './learn-success-view.component.html',
  styleUrls: ['./learn-success-view.component.scss'],
  standalone: false
})
export class LearnSuccessViewComponent {

  @Input() currentCardsLearned: number = 0;
  @Input() learnsetHasMoreCards: boolean = true;

  @Output() continueSession: EventEmitter<void> = new EventEmitter<void>();
  @Output() finishSession: EventEmitter<void> = new EventEmitter<void>();

  totalCardsLearned: number = 0;
  animatedTotal: number = 0;
  animationGrowing: boolean = false;
  motivationalQuotes: string[] = [
    "Klasse! 👏",
    "Du Maschine! 💪",
    "Weiter so! 🚀",
    "Mega! ✨",
    "Du gehst ab! 🔥",
    "Wahnsinn! 😱",
    "Super gemacht! 🌟",
    "Top! 👌",
    "Spitze! 🏅",
    "Du bist on fire! 🔥"
  ];
  randomQuote: string = '';

  constructor(private flashcardService: FlashcardService) {}

  ngOnInit() {
    this.randomQuote = this.motivationalQuotes[Math.floor(Math.random() * this.motivationalQuotes.length)];
    this.flashcardService.getTodaysLearnedFlashcards().subscribe((response) => {
      this.totalCardsLearned = response.flashcards - this.currentCardsLearned;
      this.startAnimation();
    });
  }

  startAnimation(): void {
    this.animatedTotal = this.totalCardsLearned;
    setTimeout(() => this.animateCount(), 1000);
  }

  animateCount(): void {
    const target = this.totalCardsLearned + this.currentCardsLearned;
    let increment = 1, interval = 50;

    const step = () => {
      if (this.animatedTotal < target) {
        this.animationGrowing = true; // Starte den Wachstums-Effekt
        this.animatedTotal += increment;
        setTimeout(() => step(), interval);
      } else {
        this.animationGrowing = false; // Setze den Wachstums-Effekt zurück
        this.totalCardsLearned = target;
      }
    };
    step();
  }

  continueSessionClick() {
    this.continueSession.emit();
  }

  finisheSessionClick() {
    this.finishSession.emit();
  }
}